<app-public-layout
[displayHeader]="!authenticated">
    <app-public-page>
        <app-not-found-content></app-not-found-content>
    </app-public-page>
</app-public-layout>
